import { useSelectedEligibilityFilters } from '@/features/shop-insurance/stores/eligibility-filters-store';
import type { QuoteWithROI, TraditionalLTCQuoteWithROI } from '@/features/shop-insurance/types';
import { useQuoteEligibilityFilter } from '@/features/underwriting-eligibility';

interface UseShopInsuranceUnderwritingParams {
  clientId: string | undefined;
  selectedTab: ShopInsuranceTab;
  adjustedQuotes: QuoteWithROI[];
  traditionalLTCQuotes: TraditionalLTCQuoteWithROI[];
}

export function useShopInsuranceUnderwriting({
  clientId,
  selectedTab,
  adjustedQuotes,
  traditionalLTCQuotes,
}: UseShopInsuranceUnderwritingParams) {
  const selectedEligibilityFilters = useSelectedEligibilityFilters();

  const {
    underwritingResults,
    eligibilityCounts,
    filteredAdjustedQuotes,
    filteredTraditionalLTCQuotesWithEligibility,
    showEligibilityFilter,
    isLoading,
  } = useQuoteEligibilityFilter({
    adjustedQuotes,
    filteredTraditionalLTCQuotes: traditionalLTCQuotes,
    clientId,
    selectedTab,
    selectedEligibilityFilters,
  });

  return {
    underwritingResults,
    eligibilityCounts,
    filteredAdjustedQuotes,
    filteredTraditionalLTCQuotesWithEligibility,
    showEligibilityFilter,
    isLoading,
  };
}
